import { render, staticRenderFns } from "./UsersRating.vue?vue&type=template&id=0508aa0b&scoped=true&"
import script from "./UsersRating.vue?vue&type=script&lang=js&"
export * from "./UsersRating.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0508aa0b",
  null
  
)

export default component.exports